import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito comprar algún aparato?',
    a: 'No, utilizaremos elementos que ya tienes en casa y técnicas físicas manuales.'
  }, {
    q: '¿Funciona para zumbidos muy agudos?',
    a: 'Sí, el protocolo está diseñado específicamente para las frecuencias más difíciles de enmascarar.'
  }, {
    q: '¿Cuánto tiempo tardaré en ver resultados?',
    a: 'La reducción de la ansiedad suele ser inmediata tras el primer ejercicio; la habituación nocturna toma de 3 a 7 noches.'
  }];
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0d1222] border-y border-[#1a1f3a]" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-29">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} index={i} data-id="element-31" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.1
  }} className="bg-[#1a1f3a] border border-[#2a3150] rounded-xl overflow-hidden" data-id="element-32">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-33">
        <span className="font-bold text-white text-lg pr-4" data-id="element-34">{question}</span>
        <span className={`text-[#d4a853] text-2xl transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-35">
          +
        </span>
      </button>
      <AnimatePresence data-id="element-36">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-37">
            <div className="px-6 pb-5 text-gray-300 leading-relaxed border-t border-[#2a3150] pt-4" data-id="element-38">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}